import { useQuery } from '@tanstack/react-query';

import { eventService } from '@/services/event.service';

export const useGetAllEvents = (pageNumber: number) => {
	const { data, isLoading, isError, error, refetch, isPending } = useQuery({
		queryKey: ['event', pageNumber],
		queryFn: () => eventService.getAllEvents(pageNumber),
	});
	return {
		events: data?.data ?? [],
		isLoading,
		isError,
		error,
		refetch,
		totalPages: data?.pageCount,
		isPending,
	};
};
